import React from 'react';
import { parseTable } from '../utils/markdownParser';
import InlineContent from './InlineContent';

const MarkdownTable = ({ tableLines }) => {
  const { headers, body } = parseTable(tableLines);
  if (!headers.length) return null;
  return (
    <div className="my-3 w-full overflow-x-auto rounded-xl border border-[#e8d9c4] shadow-sm">
      <table className="w-full text-[13.5px] border-collapse">
        <thead>
          <tr style={{ backgroundColor: '#543e18' }}>
            {headers.map((h, i) => (
              <th key={i} className="px-4 py-3 text-left font-semibold text-white tracking-wide whitespace-nowrap"
                style={{ borderRight: i < headers.length - 1 ? '1px solid rgba(255,255,255,0.15)' : 'none' }}>
                <InlineContent text={h} dark />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {body.map((row, ri) => (
            <tr key={ri} style={{ backgroundColor: ri % 2 === 0 ? '#ffffff' : '#fdf8f3' }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f5ece0'}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = ri % 2 === 0 ? '#ffffff' : '#fdf8f3'}>
              {row.map((cell, ci) => (
                <td key={ci} className="px-4 py-3 text-gray-700 align-top"
                  style={{ borderTop: '1px solid #f0e6d6', borderRight: ci < row.length - 1 ? '1px solid #f0e6d6' : 'none' }}>
                  <InlineContent text={cell} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MarkdownTable;